export interface SaveRequestResponse {
  Status: SaveRequestState;
}

export enum SaveRequestState {
  MailSent = 1,
  UserExistsInDbButNotInAuth0 = 2,
}